import { ForwardedRef, MutableRefObject } from 'react'

export type RefOrElementType<T = HTMLElement> =
  | ForwardedRef<T | null>
  | MutableRefObject<T | null>
  | T
  | null

export function getRefElement<T>(ref?: RefOrElementType<T>) {
  if (!ref) return null

  if (isRefObject(ref)) {
    return (ref as MutableRefObject<T>).current ?? null
  }

  return ref as T
}

function isRefObject<T>(ref?: RefOrElementType<T>): ref is MutableRefObject<T> {
  return !!ref ? typeof ref === 'object' && 'current' in ref : false
}
